import {
  IOrder,
  ISpecieLabel,
  ISpecieValue,
  IStatusCycles,
  ITypeFilters,
} from 'v2/resources/types/cycles';
import { IStatusNursery } from 'v2/resources/types/nurseries';
import { ISelect } from '../../../Home/components/Filters/types';

export const SELECT_STATUS_NUERSERY: ISelect<IStatusNursery, IStatusNursery>[] =
  [
    { id: 1, label: 'Todos', value: 'Todos' },
    { id: 2, label: 'Disponível', value: 'Disponível' },
    { id: 3, label: 'Manutenção', value: 'Manutenção' },
  ];

export const SELECT_STATUS_CYCLES: ISelect<IStatusCycles, IStatusCycles>[] = [
  { id: 1, label: 'Todos', value: 'Todos' },
  { id: 2, label: 'Preparando', value: 'Preparando' },
  { id: 3, label: 'Cultivando', value: 'Cultivando' },
  { id: 4, label: 'Despescado', value: 'Despescado' },
  { id: 5, label: 'Transferido', value: 'Transferido' },
  { id: 6, label: 'Concluído', value: 'Concluído' },
];

export const SELECT_TYPE: ISelect<ITypeFilters, ITypeFilters>[] = [
  { id: 1, label: 'Todos', value: 'Todos' },
  { id: 2, label: 'Pré-Berçário', value: 'Pré-Berçário' },
  { id: 3, label: 'Berçário', value: 'Berçário' },
  { id: 4, label: 'Engorda', value: 'Engorda' },
  { id: 5, label: 'Tanque-Rede', value: 'Tanque-Rede' },
];
export const SELECT_SPECIES: ISelect<ISpecieLabel, ISpecieValue>[] = [
  { id: 1, label: 'Todos', value: 'all' },
  { id: 2, label: 'Peixe', value: 'fish' },
  { id: 2, label: 'Camarão', value: 'shrimp' },
];
export const SELECT_ORDER: ISelect<string, IOrder>[] = [
  { id: 1, label: 'Nome', value: 'name' },
  { id: 2, label: 'Útlima modificação', value: 'last_modification' },
];
